import {getStores, getStoresFromSearch, getStoresInMap, getUserLocation} from "./stores.actions";
import {IStoreState} from "@montana/store/store";
import {generateContainer} from "../base/generate-container";

const mapState = (s: IStoreState) => s.stores;

const actions = {
    getStores,
    getUserLocation,
    getStoresInMap,
    getStoresFromSearch,
};

export const [StoresContainer, connectWithStores, useStores] = generateContainer(mapState, actions);
